export default __webpack_public_path__ + "static/youplanet-logo-b5ccbeb8fa7c15560f69161876d72206.svg";